import { Box, Button, CircularProgress } from '@mui/material'
import TextFieldNN from 'components/TextFieldNN'
import AuthTemplate from 'components/templates/AuthTemplate'
import utils from 'helpers/utils'
import useShowError from 'hooks/useShowError'
import useSnackbarStore from 'hooks/useSnackbarStore'
import axios from 'providers/axios'
import React, { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

const RequestPasswordReset: React.FC = () => {
  const location = useLocation()
  const showError = useShowError()
  const { openSnackbar } = useSnackbarStore()

  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search])

  const [email, setEmail] = React.useState(searchParams.get('email') || '')
  const [loading, setLoading] = React.useState(false)

  const requestPasswordReset = async () => {
    if (!email) return showError(new Error('Please enter your email address'))
    if (!utils.isValidEmail(email)) return showError(new Error('Please enter a valid email address'))
    setLoading(true)
    try {
      const { data } = await axios.get(`/reset-password/${email}`)
      if (data.success) {
        openSnackbar(
          'If your email address is registered, you will receive an email with instructions to reset your password',
          'success',
          false,
          10000
        )
        setEmail('')
      }
    } catch (error) {
      showError(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthTemplate>
      <Box mb="16px" maxWidth="400px" mx="auto">
        <h2 style={{ marginTop: 0, marginBottom: 32 }}>Reset password</h2>

        <TextFieldNN id="email" label="Email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" />

        <Button
          variant="contained"
          fullWidth
          disabled={loading || !utils.isValidEmail(email)}
          onClick={requestPasswordReset}
          sx={{ mt: '16px' }}
        >
          {loading ? <CircularProgress size="20px" /> : 'OK'}
        </Button>
      </Box>
    </AuthTemplate>
  )
}

export default RequestPasswordReset
